function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9977_6755)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.275 11.0476C18.275 15.6497 14.5442 19.3804 9.94217 19.3804C5.34009 19.3804 1.60938 15.6497 1.60938 11.0476C1.60938 6.44556 5.34009 2.71484 9.94217 2.71484",
  stroke: "#FFF",
  strokeWidth: 1.63154,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9447 11.0475C14.9447 13.8088 12.7062 16.0472 9.94499 16.0472C7.18374 16.0472 4.94531 13.8088 4.94531 11.0475C4.94531 8.28628 7.18374 6.04785 9.94499 6.04785",
  stroke: "#FFF",
  strokeWidth: 1.6827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.9439 12.714C10.8643 12.714 11.6105 11.9678 11.6105 11.0474C11.6105 10.127 10.8643 9.38086 9.9439 9.38086C9.02349 9.38086 8.27734 10.127 8.27734 11.0474C8.27734 11.9678 9.02349 12.714 9.9439 12.714Z",
  stroke: "#FFF",
  strokeWidth: 1.6827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.2383,
  y1: 9.66953,
  x2: 14.7296,
  y2: 6.17817,
  stroke: "#FFF",
  strokeWidth: 1.6827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6047 8.23139L12.8405 8.57359L15.2359 6.1782L19.0001 5.836L16.6047 8.23139Z",
  stroke: "#FFF",
  strokeWidth: 1.6827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8389 4.46711L12.4967 8.23131L14.8921 5.83591L15.2343 2.07172L12.8389 4.46711Z",
  stroke: "#FFF",
  strokeWidth: 1.6827,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9977_6755"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.2626,
  height: 20.2626,
  fill: "white",
  transform: "translate(0 0.393066)"
})));

function SvgIconMetas(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetas);
export default __webpack_public_path__ + "static/media/icon-metas.bc473801b434627fa2ad8ec8678bfe51.svg";
export { ForwardRef as ReactComponent };